$(function () {
    var upgradeSwiper;
    var clicked = 0, imgOverlay, slider, w;

    createTeamsUpgradeSwiper(previousWidth);
    initComparisons();


    $(window).on('windowResizeBreakpointChanged', function () {
        createTeamsUpgradeSwiper(currentWidth);
        recreateImgComp();
    });
    $(window).on('windowResizeInsideXS', function () {
        recreateImgComp();
    });


    function createTeamsUpgradeSwiper(currentWidth)
    {
        if (upgradeSwiper) {
            upgradeSwiper.destroy(true, true);
        }

        upgradeSwiper = new Swiper('.upgrade-swiper .swiper-container', {
            initialSlide: 0,
            loop: false,
            spaceBetween: 0,
            autoplay: 2000,
            nextButton: '.upgrade-swiper .swiper-button-next',
            prevButton: '.upgrade-swiper .swiper-button-prev',
            grabCursor: true,
            slidesPerView: currentWidth <= screenXsMaxWidth ? 3 : (currentWidth <= screenSmMaxWidth ? 4 : 6),
        });

        //console.log('createTeamsUpgradeSwiper', currentWidth, upgradeSwiper);
    }

    function recreateImgComp() {
        $('.img-comp-slider').remove();

        window.removeEventListener("mouseup", slideFinish);
        window.removeEventListener("touchend", slideFinish);
        window.removeEventListener("mousemove", slideMoveMouse);
        window.removeEventListener("touchmove", slideMoveTouch);

        initComparisons();
    }
    function initComparisons() {
        var x, i;
        /*find all elements with an "overlay" class:*/
        x = document.getElementsByClassName("img-comp-overlay");
        for (i = 0; i < x.length; i++) {
            /*once for each "overlay" element:
            pass the "overlay" element as a parameter when executing the compareImages function:*/
            imgOverlay = x[i];
            compareImages();
        }
    }
    function compareImages() {
        var h;
        clicked = 0;

        /*get the width and height of the img element*/
        w = $('.img-comp-full').width();
        h = $('.img-comp-full').height();
        /*set the width of the img element to 50%:*/
        imgOverlay.style.width = (w / 2) + "px";
        imgOverlay.style.height = h + 40 + "px"; // 40 - paddings
        $('.img-comp-overlay img').width(w);
        $('.img-comp-overlay').show();
        //console.log('*** w, h', w, h);

        /*create slider:*/
        slider = document.createElement("DIV");
        slider.setAttribute("class", "img-comp-slider");
        /*insert slider*/
        imgOverlay.parentElement.insertBefore(slider, imgOverlay);
        /*position the slider in the middle:*/
        slider.style.top = (h / 2) - (slider.offsetHeight / 2)  + (slider.offsetHeight * 0.75) + "px";
        slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";

        /*execute a function when the mouse button is pressed:*/
        slider.addEventListener("mousedown", slideReady);
        /*and another function when the mouse button is released:*/
        window.addEventListener("mouseup", slideFinish);
        /*or touched (for touch screens:*/
        slider.addEventListener("touchstart", slideReady);
        /*and released (for touch screens:*/
        window.addEventListener("touchend", slideFinish);
    }
    function slideReady(e) {
        if (e.cancelable) {
            /*prevent any other actions that may occur when moving over the image:*/
            e.preventDefault();
        }
        /*the slider is now clicked and ready to move:*/
        clicked = 1;
        /*execute a function when the slider is moved:*/
        window.addEventListener("mousemove", slideMoveMouse);
        window.addEventListener("touchmove", slideMoveTouch);
    }
    function slideFinish() {
        /*the slider is no longer clicked:*/
        clicked = 0;
    }
    function getCursorPos(e) {
        var a, x = 0;
        e = e || window.event;
        /*get the x positions of the image:*/
        a = imgOverlay.getBoundingClientRect();
        /*calculate the cursor's x coordinate, relative to the image:*/
        x = e.pageX - a.left;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        return x;
    }
    function slideMoveMouse(e) {
        var pos;
        /*if the slider is no longer clicked, exit this function:*/
        if (clicked == 0) return false;
        /*get the cursor's x position:*/
        pos = getCursorPos(e)
        /*prevent the slider from being positioned outside the image:*/
        if (pos < 0) pos = 0;
        if (pos > w) pos = w;
        /*execute a function that will resize the overlay image according to the cursor:*/
        slide(pos);
    }
    function slideMoveTouch(e) {
        var pos;
        /*if the slider is no longer clicked, exit this function:*/
        if (clicked == 0) return false;
        /*get the cursor's x position:*/
        pos = parseInt(e.changedTouches[0].clientX);
        /*prevent the slider from being positioned outside the image:*/
        if (pos < 0) pos = 0;
        if (pos > w) pos = w;
        /*execute a function that will resize the overlay image according to the cursor:*/
        slide(pos);
    }
    function slide(x) {
        /*resize the image:*/
        imgOverlay.style.width = x + "px";
        /*position the slider:*/
        slider.style.left = x - (slider.offsetWidth / 2) + "px";
    }

    $('.how_it_works .with, .how_it_works .without').on('click', function(e) {
        $('.img-comp-overlay').css('transition', '0.5s ease-out');
        $('.img-comp-slider').css('transition', '0.5s ease-out');

        slide(e.target.className === 'with' ? 0 : w);

        setTimeout(function () {
            $('.img-comp-overlay').css('transition', '0s');
            $('.img-comp-slider').css('transition', '0s');
        }, 500);
    });
});